import { useSelector } from 'react-redux';
import { pusherState } from 'Src/contexts/PusherDuck.models';

export const usePusherRedirectionState = () => {
  const pusher = useSelector<{ pusher: pusherState }>((state) => state.pusher) as pusherState;
  const { isRedirectionEnabled } = pusher;

  return { isRedirectionEnabled };
};
